import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';

const STORAGE_KEY = 'iiy_announce_dismissed_v1';

const Message = () => (
  <span className="inline-flex items-center gap-2 px-8 text-[13px] md:text-sm font-medium">
    <Sparkles className="w-4 h-4 text-amber-300 flex-shrink-0" />
    <span>
      <span className="font-bold text-amber-300">Bumper Offer:</span>{' '}
      Save more with our multi-bottle Bumper Offer &mdash; UK VAT &amp; delivery included, applied automatically at checkout.
    </span>
    <span className="mx-3 text-amber-300/60">&bull;</span>
    <Sparkles className="w-4 h-4 text-amber-300 flex-shrink-0" />
    <span>
      <span className="font-bold text-amber-300">IIY Rewards:</span>{' '}
      Earn points on every order &mdash; get <span className="font-bold">100 welcome points</span> when you create your free account.
    </span>
    <span className="font-semibold underline underline-offset-2">Shop now &rarr;</span>
  </span>
);

// One repeating group; rendered twice inside the track for a seamless -50% loop.
const Group = () => (
  <span className="inline-flex flex-shrink-0" aria-hidden="false">
    <Message />
    <Message />
    <Message />
  </span>
);

export const AnnouncementBar = () => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const close = (e) => {
    e.stopPropagation();
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div
      className="relative bg-emerald-900 text-emerald-50 cursor-pointer select-none"
      data-testid="announcement-bar"
      onClick={() => navigate('/products')}
      role="button"
      aria-label="Bumper Offer — shop now"
    >
      <div className="iiy-marquee py-2.5 pr-10">
        <div className="iiy-marquee-track" data-testid="announcement-marquee">
          <Group />
          <Group />
        </div>
      </div>
      <button
        onClick={close}
        aria-label="Dismiss announcement"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-full hover:bg-white/10 transition-colors z-10"
        data-testid="announcement-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
